import { render, staticRenderFns } from "./SendEmailToCasualPopUp.vue?vue&type=template&id=54d8f2c9&scoped=true&"
import script from "./SendEmailToCasualPopUp.vue?vue&type=script&lang=js&"
export * from "./SendEmailToCasualPopUp.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailToCasualPopUp.vue?vue&type=style&index=0&id=54d8f2c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d8f2c9",
  null
  
)

export default component.exports